import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconUploadComponent } from "./med-icon-upload.component";

@NgModule({
  declarations: [
    MedIconUploadComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconUploadComponent,
  ],
})
export class MedIconUploadModule { }
